import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // inițializează i18next înainte de orice render
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA: înregistrăm service worker-ul DOAR în production. În development, CRA folosește deja
// dev server cu HMR și un SW activ ar putea cache-ui fișiere stale și induce confuzie la testare.
// În producție: cache static pentru offline + lansare rapidă din ecranul de start (Add to Home Screen).
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => console.warn('Service worker registration failed:', err));
  });
}

reportWebVitals();
